// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M11.64 8.32L13.2 6.76C14.29 5.67 14.29 3.9 13.2 2.8C12.1 1.71 10.33 1.71 9.24 2.8L7.68 4.36',
  'M4.36 7.68L2.8 9.24C1.71 10.33 1.71 12.1 2.8 13.2C3.9 14.29 5.67 14.29 6.76 13.2L8.32 11.64',
  'M5.35 1.75V3.25M1.75 5.35H3.25M10.65 12.75V14.25M12.75 10.65H14.25',
];
